var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPricingPlan(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "23px",
    height: "22.1px",
    viewBox: "0 0 23 22.1",
    style: {
      enableBackground: "new 0 0 23 22.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Group",
    transform: "translate(-9.2 -9.436)",
    d: "M17.1,16.7h6.9v1.7h-6.9V16.7z M17.1,20.5H28v1.7H17.1V20.5z M31.7,9.5 c-0.3-0.1-0.6-0.1-0.9,0.1l-2.4,2l-2.4-2c-0.3-0.3-0.8-0.3-1.1,0l-2.4,2l-2.4-2c-0.3-0.3-0.8-0.3-1.1,0l-2.4,2l-2.4-2 c-0.3-0.2-0.6-0.3-0.9-0.1c-0.3,0.1-0.5,0.4-0.5,0.8v14.5H10c-0.5,0-0.8,0.4-0.8,0.8c0,0,0,0,0,0v2c0,2.1,1.7,3.9,3.9,3.9h15.1 c2.2,0,4-1.7,4-3.9c0,0,0,0,0,0V10.3C32.2,10,32,9.7,31.7,9.5z M30.5,27.6c0,1.3-1.1,2.3-2.4,2.3c-1.2,0-2.2-1-2.3-2.3v-2 c0-0.5-0.4-0.8-0.8-0.8c0,0,0,0,0,0H14.6V12.1l1.6,1.3c0.3,0.3,0.8,0.3,1.1,0l2.4-2l2.3,2c0.3,0.3,0.8,0.3,1.1,0l2.4-2l2.4,2 c0.3,0.3,0.8,0.3,1.1,0l1.5-1.3L30.5,27.6z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPricingPlan);
export default __webpack_public_path__ + "static/media/pricing_plan.dcc38d22.svg";
export { ForwardRef as ReactComponent };